
import {Component, Vue} from "vue-property-decorator";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import PhoneInput from "@/components/PhoneInput.vue";
import {IAppState} from "@/interfaces/app-state.interface";

@Component({
  components: {PhoneInput}
})
export default class PhoneField extends Vue {

  get storeState(): IAppState { return this.$store.state; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get viewMode() { return !this.userAccess.scCarMk; }

  get modelValue() { return this.formModel.phone; }
  set modelValue(value) {
    this.$store.commit('car/setFormProperty', {
      formName: 'formModel',
      name: 'phone',
      value
    });
  };
}
